<template>
  <div
    class="mobile-header bg-color-head" 
  >
    <div class="left">
      <!-- <img src="../../assets/images/header/side.png" style="width: clamp(20px,3.5vw,25px);margin: 0  clamp(2px,1vw,8px) 0 0;"
        class="text-20 text-color-2"
        @click.prevent.stop="handleMenu"
      /> -->
      <div class="menu-icon-bg" @click.prevent.stop="handleMenu">
        <svg  viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="menu-icon-svg">
<path d="M9.58317 5.83325C9.58317 5.61224 9.67097 5.40028 9.82725 5.244C9.98353 5.08772 10.1955 4.99992 10.4165 4.99992H17.4998C17.6093 4.9999 17.7177 5.02144 17.8188 5.06332C17.9199 5.10519 18.0118 5.16657 18.0892 5.24395C18.1666 5.32134 18.228 5.41321 18.2699 5.51432C18.3117 5.61543 18.3333 5.72381 18.3333 5.83325C18.3333 5.9427 18.3117 6.05107 18.2699 6.15218C18.228 6.2533 18.1666 6.34517 18.0892 6.42255C18.0118 6.49994 17.9199 6.56132 17.8188 6.60319C17.7177 6.64506 17.6093 6.6666 17.4998 6.66659H10.4165C10.1955 6.66659 9.98353 6.57879 9.82725 6.42251C9.67097 6.26623 9.58317 6.05427 9.58317 5.83325ZM1.6665 10.8333C1.6665 10.7238 1.68806 10.6155 1.72994 10.5143C1.77182 10.4132 1.8332 10.3214 1.91058 10.244C1.98796 10.1666 2.07983 10.1052 2.18093 10.0634C2.28204 10.0215 2.3904 9.99992 2.49984 9.99992H17.4998C17.6093 9.9999 17.7177 10.0214 17.8188 10.0633C17.9199 10.1052 18.0118 10.1666 18.0892 10.244C18.1666 10.3213 18.228 10.4132 18.2699 10.5143C18.3117 10.6154 18.3333 10.7238 18.3333 10.8333C18.3333 10.9427 18.3117 11.0511 18.2699 11.1522C18.228 11.2533 18.1666 11.3452 18.0892 11.4226C18.0118 11.4999 17.9199 11.5613 17.8188 11.6032C17.7177 11.6451 17.6093 11.6666 17.4998 11.6666H2.49984C2.27882 11.6666 2.06686 11.5788 1.91058 11.4225C1.7543 11.2662 1.6665 11.0543 1.6665 10.8333ZM1.6665 15.8333C1.6665 15.6122 1.7543 15.4003 1.91058 15.244C2.06686 15.0877 2.27882 14.9999 2.49984 14.9999H17.4998C17.6093 14.9999 17.7177 15.0214 17.8188 15.0633C17.9199 15.1052 18.0118 15.1666 18.0892 15.2439C18.1666 15.3213 18.228 15.4132 18.2699 15.5143C18.3117 15.6154 18.3333 15.7238 18.3333 15.8333C18.3333 15.9427 18.3117 16.0511 18.2699 16.1522C18.228 16.2533 18.1666 16.3452 18.0892 16.4226C18.0118 16.4999 17.9199 16.5613 17.8188 16.6032C17.7177 16.6451 17.6093 16.6666 17.4998 16.6666H2.49984C2.27882 16.6666 2.06686 16.5788 1.91058 16.4225C1.7543 16.2662 1.6665 16.0543 1.6665 15.8333ZM4.1665 4.99992C3.94551 4.99995 3.73358 5.08776 3.57733 5.24404C3.42108 5.40032 3.3333 5.61226 3.3333 5.83325C3.3333 6.05424 3.42108 6.26619 3.57733 6.42246C3.73358 6.57874 3.94551 6.66655 4.1665 6.66659H5.83317C6.05416 6.66655 6.26609 6.57874 6.42234 6.42246C6.5786 6.26619 6.66638 6.05424 6.66638 5.83325C6.66638 5.61226 6.5786 5.40032 6.42234 5.24404C6.26609 5.08776 6.05416 4.99995 5.83317 4.99992H4.1665ZM1.6665 5.83325C1.6665 5.17021 1.9299 4.53433 2.39874 4.06548C2.86758 3.59664 3.50346 3.33325 4.1665 3.33325H5.83317C6.49621 3.33325 7.1321 3.59664 7.60094 4.06548C8.06978 4.53433 8.33317 5.17021 8.33317 5.83325C8.33317 6.49629 8.06978 7.13218 7.60094 7.60102C7.1321 8.06986 6.49621 8.33325 5.83317 8.33325H4.1665C3.50346 8.33325 2.86758 8.06986 2.39874 7.60102C1.9299 7.13218 1.6665 6.49629 1.6665 5.83325Z" fill="currentColor"></path>
</svg>
      </div>
      <img
        src="../../assets/images/b3337.png"
        alt=""
        class="logo"
        onerror="this.style.display='none';"
      />
      <!-- <img
        :src="siteConfig&&siteConfig.site_logo"
        alt=""
        style="height:36px;"
        onerror="this.style.display='none';"
      /> -->
    </div>
    <!-- 未登录 -->
    <div class="header-right" v-if="!isLogin">
    <!-- <div class="flex items-center h-full header-right" > -->
      <div class="flex items-center right-btns">
         <button class="header-btn-img btn-login" @click="handleLogin">
          <span class="btn-text">{{ $t("A0002") }}</span>
        </button>
        <button class="header-btn-img btn-register" @click="handleRegister">
          <span class="btn-text btn-text-register">{{ $t("A0003") }}</span>
        </button>
      </div>
    </div>
    <!-- 已登陆 -->
    <div class="header-right" v-else>
    <!-- <div class="flex items-center" v-if="!isLogin"> -->
      <div
        class="flex items-center shrink-0 text-11 h-40 pr-4 pt-4 pb-4 font-700 rounded-5"
      >
        <!-- <button
          class="flex items-center justify-center rounded-6 px-10 h-32 mr-8"
          @click="nav('/deposit')"
          style="color: #fff;background-color:#007fff;box-shadow: 0 0 #0000, 0 0 #0000, 0px 0px 8px #007fff;font-weight: bold;font-size: clamp(10px,3vw,13px);"
        >
          {{ $t("C0012") }}
        </button> -->
        <div
          class="flex items-center"
          @click="handleCashVfm"
        >
          <div class="balance-area">
             <div class="pig-icon-bg">
              <img src="../../assets/images/withdraw-head.png" class="pig-icon"/>
            </div>
              <div class="flex" style="flex-direction: column;align-items: flex-end;margin-left: 10px;">
                  <div>
                    <span class="balance-prefix">R$</span>
                    <span class="balance-num">{{ userinfo.money }}</span>
                  </div>
                  <!-- <div>
                    <span style="color: #ffffff99;margin-right: 6px;">Saldo</span>
                  </div> -->
              </div>

          </div>
        </div>
        <button class="search-btn" @click="nav('/slot')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f7fb43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </button>

        <!-- <div class="language-selector" @click.stop="toggleLanguageMenu">
          <img src="../../assets/images/icon/language.png" style="width: clamp(24px,4.5vw,32px);height: clamp(24px,4.5vw,32px);"/>
          <div v-if="showLanguageMenu" class="language-dropdown">
            <div class="language-option">
              <img src="../../assets/images/icon-phone.png" style="width: 24px;height: 24px;border-radius: 50%;"/>
              <span>português (Brasil)</span>
            </div>
          </div>
        </div> -->
      </div>

      <!-- <div class="flex justify-center items-center w-32 h-32 relative ml-10" @click="nav('/notification')">
        <i class="sysicon-new-message text-color-2 text-20"></i>
        <div
          v-if="notificationUnread"
          class="rounded-999 bg-color-main shrink-0 text-color-0 flex items-center justify-center font-700 px-2 min-w-15 h-15 text-10 absolute t-0 r-0"
        >
          {{ notificationUnread }}
        </div>
      </div> -->
    </div>
  </div>
</template>
<script setup>
import { useNav } from "@/hooks/useNav";
import { useUserStore } from "@/stores/modules/user";
import { useAppStore } from "@/stores/modules/app";
import eventBus from "@/utils/eventBus";
import { computed, ref } from "vue";
const userStore = useUserStore();
const appStore = useAppStore()
const nav = useNav();
const props = defineProps({
  showCash: {
    type: Boolean,
    default: false
  }
});
const isLogin = computed(() => {
  return userStore.isLogin;
});
const userinfo = computed(() => {
  return userStore.userinfo;
});
// 未读消息
const notificationUnread = computed(() => {
  return userStore.notificationUnread;
});
const siteConfig = computed(()=>{
  return appStore.siteConfig
})

const emit = defineEmits(["onmenu", "oncash"]);
function handleLogin(){
  eventBus.emit("Login", 'in');
}
function handleRegister(){
  eventBus.emit("Login", 'up');
}
function handleMenu() {
  emit("onmenu");
}
function handleCashVfm() {
  emit("oncash");
}
</script>
<style lang="scss" scoped>
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: clamp(6px, 2vw, 10px) clamp(6px, 2vw, 10px);
  height: var(--app-header-height);
  box-sizing: border-box;
  width: 100%;
  box-shadow: 0 4px 10px rgba(0, 40, 50, 0.15);
}
.mobile-header .left {
  display: flex;
  align-items: center;
  gap: clamp(4px, 1.5vw, 8px);
  flex: 1;
  min-width: 0;
}
.menu-icon-bg {
  background: none;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease;
  margin-left: 10px;
  border-radius: 5px;
}
.menu-icon-bg:active {
  transform: scale(0.92);
  background: none;
}
.menu-icon-svg {
  padding: 5px;
  width: 100%;
  height: 100%;
  fill: #fff;
  pointer-events: none;
}
.mobile-header .left .logo {
  max-height: clamp(28px, 8vw, 38px);
  height: auto;
  width: auto;
  max-width: clamp(90px, 28vw, 140px);
  object-fit: contain;
  flex-shrink: 1;
}
/* 右侧按钮区域 */
.mobile-header .header-right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    position: relative;
    box-sizing: border-box;
    border-radius: 10px;
    gap: clamp(4px, 1.5vw, 8px);
    padding: 0;
    flex-shrink: 0;
}
.right-btns button {
  font-size: clamp(10px, 3vw, 14px);
  width: clamp(50px, 19vw, 100px);
  height: clamp(20px, 10vw, 30px);
  margin-right: clamp(2px, 1.5vw, 10px);
}
.header-btn-img {
  position: relative;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
  overflow: hidden;
  padding: 0;
}
.btn-login {
  background: linear-gradient(180deg, #13c96a, #1d9554);
}
.btn-login .btn-text {
  color: #fff;
}
.btn-register {
  background: linear-gradient(180deg, #ffc271, #f2910d);
}
.btn-register .btn-text-register {
  color: #fff;
}
.btn-text {
  position: relative;
  z-index: 1;
  font-weight: 800;
  font-size: clamp(8px, 3vw, 12px);
}
.bg-color-head{
  background: #2b4f14;
}
.balance-area {
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 3px 3px 3px 10px;
  cursor: pointer;
}
.balance-prefix {
  color: #fff;
  font-size: clamp(10px, 3vw, 13px);
  font-weight: 800;
  margin-right: 4px;
}
.balance-num {
  color: #fff;
  font-size: clamp(10px, 3vw, 13px);
  font-weight: 800;
  margin-right: 6px;
}
.pig-icon-bg {
  width: clamp(20px, 5vw, 10px);
  height: clamp(20px, 5vw, 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pig-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.search-btn {
  border-radius: 6.6px;
  box-shadow: 0 4px 10px rgba(0, 40, 50, 0.15);
  background: #2b4f14;
  border: none;
  padding: 8px 10px;
  margin-left: 8px;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
